import { supabase } from "../supabaseClient";

export const getAgendamentos = async () => {
  const { data } = await supabase
    .from("agendamentos")
    .select(
      `
      *,
      familia:familia_id (nome, telefone),
      baba:baba_id (nome),
      vendas (id)
    `,
    )
    .order("inicio", { ascending: true });

  return data;
};

export const alterarStatus = async (id, status) => {
  return await supabase.from("agendamentos").update({ status }).eq("id", id);
};

export const cancelarAgendamento = async (id, userId) => {
  return await supabase.rpc("cancelar_agendamento", {
    p_agendamento_id: id,
    p_user_id: userId,
  });
};
